// import { getLevelIds } from "../../http/index.js";
const state = {
  level: 0,
  currentIndex: 0,
  nextIndex: 0,
  levelTotal: 0,
  levelMessage: {},
  mode: "simple",
};
const mutations = {
  SET_LEVEL(state, index) {
    state.level = index;
  },
  SET_CURRENTINDEX(state, index) {
    state.currentIndex = index;
  },
  SET_NEXTINDEX(state, index) {
    state.nextIndex = index;
  },
  SET_MODE(state, mode) {
    state.mode = mode;
  },
  SET_LEVELMESSAGE(state, mode) {
    state.mode = mode;
  },
  SET_LEVELTOTAL(state, total) {
    state.levelTotal = total;
  },
};
const getters = {
  level: (state) => state.level,
  currentIndex: (state) => state.currentIndex,
  nextIndex: (state) => state.nextIndex,
  levelTotal: (state) => state.levelTotal,
  mode: (state) => state.mode,
};
const actions = {
  // async getLevelTotal({ commit }) {
  //   const levelIds = await getLevelIds();
  //   const levelTotal = levelIds.length || 1;
  //   commit("SET_LEVELTOTAL", levelTotal);
  //   return levelIds;
  // },
};
export default {
  state,
  mutations,
  getters,
  actions,
};
